const ART = [
  // {
  //   img: 'cookie.JPG',
  //   title: 'My cat, Cookie',
  // },
  

  {
    img: 'Piece11.webp',
    title: 'P',
  },
  {
    img: 'alissa.webp',
    title: 'veg',
    cropAspectRatio: '1054 / 906',
  },
  {
    img: 'em.webp',
    title: 'P',
  },
  {
    img: 'parents.webp',
    title: 'parents',
  },
  {
    img: 'Piece4.webp',
    title: 'P',
  },
  {
    img: 'fka.webp',
    title: 'P',
  },
  {
    img: 'still4.webp',
    title: 'alissa (progress)',
  },
  {
    img: 'Piece1.webp',
    title: 'P',
  },
  {
    img: 'mango.webp',
    title: 'P',
  },
  {
    img: 'Piece10.webp',
    title: 'P',
    cropAspectRatio: '1446 / 1550',
  },
  {
    img: 'ally.webp',
    title: 'P',
  },
  {
    img: 'veg.webp',
    title: 'veg',
  },
  {
    img: 'iago.webp',
    title: 'P',
  },
  {
    img: 'Piece2.webp',
    title: 'P',
  },
  {
    img: 'pear.webp',
    title: 'P',
  },
  {
    img: 'brent.webp',
    title: 'P',
  },
  {
    img: 'Piece3.webp',
    title: 'P',
  },
  {
    img: 'coke.webp',
    title: 'P',
  },
  {
    img: 'Piece5.webp',
    title: 'P',
  },
  {
    img: 'self.webp',
    title: 'P',
  },
  {
    img: 'emille.webp',
    title: 'parents',
  },
];
export default ART;
